import { LanguageKey, useLocale } from '@multiplatform-apps/service-trips';
import { useEffect } from 'react';

/**
 * Keeps <html lang> in sync with the active locale.
 * Maps internal LanguageKey values to BCP 47 language tags.
 * Must only be used inside the web app — not in shared libs.
 */
const LANG_MAP: Partial<Record<LanguageKey, string>> = { no: 'nb' };

export const useHtmlLang = (): void => {
  const { currentLanguage } = useLocale();
  useEffect(() => {
    document.documentElement.lang = LANG_MAP[currentLanguage] ?? currentLanguage;
  }, [currentLanguage]);
};
